export function isFlowRuntimeEnabled(flow) {
  if (!flow || typeof flow !== 'object') return true;
  if (_explicitlyFalse(flow.isActive)) return false;
  if (_explicitlyFalse(flow.enabled)) return false;
  return true;
}

export function flowRuntimeStatusLabel(flow) {
  return isFlowRuntimeEnabled(flow) ? 'Active' : 'Disabled';
}

export function flowDisabledUserMessage(error, result) {
  const code = result?.error || result?.code || '';
  const text = `${error?.message || ''} ${result?.message || ''} ${result?.error || ''}`;
  if (code === 'flow_disabled' || /flow_disabled|This Flow has been disabled/i.test(text)) {
    return 'This Flow has been disabled.';
  }
  return null;
}

function _explicitlyFalse(value) {
  if (value === false) return true;
  if (typeof value === 'string' && ['false', '0', 'no', 'off'].includes(value.trim().toLowerCase())) {
    return true;
  }
  return false;
}
